import React, { useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import GlobalSearch from "./GlobalSearch";
import ExportMenu from "./ExportMenu";
import NewRequestDialog from "./NewRequestDialog";

// Dashboard search / export / quick-create controls. variant "topbar" is
// styled to sit directly inside the blue Home top bar (compact, light-on-dark).
const DashboardActionBar = ({ variant = "standalone" }) => {
  const [newRequestOpen, setNewRequestOpen] = useState(false);
  const isTopbar = variant === "topbar";

  return (
    <Box sx={{
      display: "flex", alignItems: "center", gap: isTopbar ? 1 : 1.5,
      ...(isTopbar ? {} : { justifyContent: "space-between", flexWrap: "wrap", mb: 2.5, width: "100%" }),
    }}>
      <GlobalSearch variant={isTopbar ? "dark" : "light"} />

      <Box sx={{ display: "flex", alignItems: "center", gap: isTopbar ? 0.75 : 1.5, flexShrink: 0 }}>
        <ExportMenu variant={isTopbar ? "dark" : "light"} />
        <Button
          variant="contained"
          size={isTopbar ? "small" : "medium"}
          startIcon={<AddIcon />}
          onClick={() => setNewRequestOpen(true)}
          sx={isTopbar ? {
            borderRadius: "8px", textTransform: "none", fontWeight: 700, boxShadow: "none",
            whiteSpace: "nowrap", backgroundColor: "#fff", color: "#2f63ad",
            "&:hover": { backgroundColor: "#eef3fb", boxShadow: "none" },
          } : {
            borderRadius: "10px", textTransform: "none", fontWeight: 700, boxShadow: "none",
            backgroundColor: "#2f63ad", "&:hover": { backgroundColor: "#1f4f94", boxShadow: "none" },
          }}
        >
          New Request
        </Button>
      </Box>

      <NewRequestDialog open={newRequestOpen} onClose={() => setNewRequestOpen(false)} />
    </Box>
  );
};

export default DashboardActionBar;
